import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { Notify } from "../../Handlers/Notifications";
import { InterActive } from "../../utilities/ViewModelStructure";
import { Globals } from "../../Globals/GlobalObs";

export class AddEmployeeAccountVM extends InterActive{
    private rolesList:{label:string , value:string}[] = []
    private employeeData:{name:string, role:string , password:string } = {name:'' , role:'' , password:''}
    private confirmPassword:string = ''

    public get RolesList():{label:string , value:string}[]{ return this.rolesList }
    public get data():{name:string, role:string , password:string } {return this.employeeData}
    public get ConfPassword():string { return this.confirmPassword }

    public set Name(value:string ){ this.employeeData.name = value;  this.update() }
    public set Role(value:string){ this.employeeData.role= value; this.update() }
    public set Password(value:string){ this.employeeData.password = value; this.update() }
    public set ConfPassword(value:string) { this.confirmPassword = value; this.update() }


    public send(){
        if(this.validate()){
            this.loading(
                async()=>{
                    try{
                        const response = await ApiRequest.addEmployeeAccount(this.employeeData)
                        if(response){
                            if(response.status === HttpStatusCode.Ok){
                                if(response.data.status){
                                    this.employeeData= {name:'' , role:'' , password:''}
                                    this.confirmPassword= ''
                                    Notify({type:'success' , title:'نجاح العملية' , body:'تمت العملية بنجاح'})
                                }else {
                                    Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                                }
                            }else{
                                Notify({type:'danger' , title:'فشل العملية' , body:'فشل العملية ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                            }
                        }
                    }catch{
                        Notify({type:'danger' , title:'فشل العملية' , body:'فشل العملية ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})

                    }
                }
            )
        }
    }

    public getRoles(){
        this.loading(
            async()=>{
                try{
                    const result = await ApiRequest.getRoles()
                    if(result){
                        if(result?.status === HttpStatusCode.Ok){
                            if(result.data.status){
                                result.data.data.map(i=>this.rolesList.push({label:i.role , value:i.id}))
                                this.update()
                            }else {
                                Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'برجاء مراجعة الاتصال بالانترنت'})
                            }
                        }else {
                            Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'برجاء مراجعة الاتصال بالانترنت'})
                        }
                    }
                }catch{}
            }
        )
    }

    private validate():boolean{
        if(!this.employeeData.name){ Notify({type:'danger' , title:'بيانات غير صالحة' , body:'برجاء ادخال الاسم'}) ;return false; }
        if(!this.employeeData.role){ Notify({type:'danger' , title:'بيانات غير صالحة' , body:'برجاء اختيار الوظيفة'}) ;return false; }
        if(this.employeeData.password){
            if(!this.confirmPassword){ Notify({type:'danger' , title:'بيانات غير صالحة' , body:'برجاء ادخال تأكيد كلمة السر'}) ;return false; }
            if(this.employeeData.password !== this.confirmPassword){ Notify({type:'danger' , title:'بيانات غير صالحة' , body:'برجاء ادخل تأكيد كلمة السر صحيح'}) ;return false; }
        }
        return true;
    }
}